import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaInformacionDireccionesListaComponent {
  empresaId = undefined
  data = {}

  constructor (EmpresaInformacionDirecciones) {
    this.EmpresaInformacionDireccionesService = EmpresaInformacionDirecciones
  }

  $onInit () {
    this.promise = this.EmpresaInformacionDireccionesService.get(this.empresaId)
      .then((response) => (this.data = response.data))
  }

  actualizarPrincipal (item) {
    item.matriz = true
    this.data.direcciones = this.data.direcciones.filter((items) => {
      if (items.indice !== item.indice) {
        items.matriz = false
      }
      return items
    }).sort((item, items) => items.matriz - item.matriz)
  }

  eliminar (item) {
    this.data.direcciones = this.data.direcciones.filter((items) => items.indice !== item.indice)
  }
}

module.component('empresaInformacionDireccionesLista', {
  controller: EmpresaInformacionDireccionesListaComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/informacion/direcciones/lista/component.js